import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firbase/firebase";
import {
  updateStatsOnCreate,
  updateStatsOnDelete,
} from "../page/admin/dashboard/StatsService";

export const addVideo = createAsyncThunk(
  "videos/addVideos",
  async (VideoData, { rejectWithValue }) => {
    try {
      // const createdAt = new Date().toLocaleString("en-IN", {
      //   timeZone: "Asia/Kolkata",
      // });

      const createdAt = serverTimestamp();
      const docRef = await addDoc(collection(db, "video"), {
        ...VideoData,
        createdAt,
      });

      await updateStatsOnCreate("videos", VideoData.status);

      return { id: docRef.id, ...VideoData, createdAt };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchVideo = createAsyncThunk(
  "videos/fetchvideos",
  async (_, { rejectWithValue }) => {
    try {
      const querySnapshot = await getDocs(collection(db, "video"));
      const videoData = [];
      querySnapshot.forEach((doc) => {
        videoData.push({ id: doc.id, ...doc.data() });
      });
      return videoData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const deleteVideo = createAsyncThunk(
  "videos/deleteVideo",
  async ({ id }, { rejectWithValue }) => {
    try {
      console.log("deletevideo id", id);

      const snap = await getDoc(doc(db, "video", id));
      const realData = snap.data();

      await updateStatsOnDelete("videos", realData.createdAt, realData.status);
      await deleteDoc(doc(db, "video", id));

      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const updateVideo = createAsyncThunk(
  "videos/updateVideo",
  async ({ id, videoData }, { rejectWithValue }) => {
    try {
      const updatedAt = serverTimestamp();

      const videoRef = doc(db, "video", id);
      await updateDoc(videoRef, { ...videoData, updatedAt });

      console.log("videoData", videoData);
      console.log("videodata status", videoData.status);


      videoData.status === "published"
        ? await updateStatsOnCreate("videos", videoData.status)
        : await updateStatsOnDelete(
            "videos",
            videoData.createdAt,
            videoData.status,
          );

      return { id, ...videoData, updatedAt };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const VideoSlice = createSlice({
  name: "videos",
  initialState: {
    videos: [],
    loading: {
      fetch: false,
      create: false,
      update: false,
      delete: false,
    },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addVideo.pending, (state) => {
        state.loading.create = true;
      })
      .addCase(addVideo.fulfilled, (state, action) => {
        state.loading.create = false;
        state.videos.push(action.payload);
      })
      .addCase(addVideo.rejected, (state, action) => {
        state.loading.create = false;
        state.error = action.payload;
      })
      .addCase(fetchVideo.pending, (state) => {
        state.loading.fetch = true;
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.loading.fetch = false;
        state.videos = action.payload;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.loading.fetch = false;
        state.error = action.payload;
      })
      .addCase(deleteVideo.pending, (state) => {
        state.loading.delete = true;
      })
      .addCase(deleteVideo.fulfilled, (state, action) => {
        state.loading.delete = false;
        state.videos = state.videos.filter(
          (item) => item.id !== action.payload,
        );
      })
      .addCase(deleteVideo.rejected, (state, action) => {
        state.loading.delete = false;
        state.error = action.payload;
      })
      .addCase(updateVideo.pending, (state) => {
        state.loading.update = true;
      })
      .addCase(updateVideo.fulfilled, (state, action) => {
        state.loading.update = false;
        const index = state.videos.findIndex(
          (video) => video.id === action.payload.id,
        );
        if (index !== -1) {
          state.videos[index] = { ...state.videos[index], ...action.payload };
        }
      })
      .addCase(updateVideo.rejected, (state, action) => {
        state.loading.update = false;
        state.error = action.payload;
      });
  },
});

export default VideoSlice.reducer;
